import { Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { theme } from "../../theme";

interface SubjectMessageModalProps {
    open: boolean;
    title: string;
    description: string;
    message: string;
    placeholder?: string;
    onMessageChange: (message: string) => void;
    onOk: () => void;
    onCancel: () => void;
}

const SubjectMessageModal = ({ open, title, description, message, placeholder, onMessageChange, onOk, onCancel }: SubjectMessageModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            // antd v4 nu rezerva loc pentru butonul de inchidere in header, titlurile lungi ajung sub X
            title={<div style={{ paddingRight: '24px' }}>{title}</div>}
            width="500px"
            okText={t('account.confirm')}
            cancelText={t('account.cancel')}
            cancelButtonProps={{
                style: {
                    background: theme.green,
                    border: theme.green,
                    color: theme.white,
                    borderRadius: '10px'
                }
            }}
            okButtonProps={{
                style: message?.trim() ? {
                    background: theme.secondColor,
                    border: theme.secondColor,
                    borderRadius: '10px'
                } : {
                    background: theme.disabledGray,
                    border: theme.disabledGray,
                    color: 'rgba(0, 0, 0, 0.25)',
                    borderRadius: '10px',
                    cursor: 'not-allowed'
                },
                disabled: !message?.trim()
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <Typography>
                    {description}
                </Typography>

                <textarea
                    rows={4}
                    placeholder={placeholder ?? "Mesaj..."}
                    value={message}
                    onChange={(e) => onMessageChange(e.target.value)}
                />
            </div>
        </Modal>
    );
};

export default SubjectMessageModal;
